import React from "react";
import styled from "styled-components";
import { Button, Typography } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";

import ArrowBack from "../../../assets/svg/ArrowBack";
import { WARNING_600 } from "../../../constant/colors";

const { Text } = Typography;

const NavigateButton = styled(Button)`
  display: flex;
  align-items: center;
`;
const NavigateMPDButton = ({ buttonText, id, scrollToSection, color = WARNING_600 }) => {
  const history = useHistory();
  const location = useLocation();
  const { patientId, journeyId } = useParams();
  return (
    <NavigateButton
      type="link"
      id={id}
      onClick={() =>
        history.push(`/patient/${patientId}/journey/${journeyId}/edit`, {
          path: location.pathname,
          scrollToSection
        })
      }
    >
      <Text
        style={{
          marginRight: "5px",
          color,
          fontFamily: "Open Sans",
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "150%",
          letterSpacing: "0%",
          verticalAlign: "middle"
        }}
      >
        {buttonText}
      </Text>
      <ArrowBack color={color} rotate={true} />
    </NavigateButton>
  );
};

export default NavigateMPDButton;
